import React, { useState, useEffect } from 'react';

import AppsTab from '../../components/Integration/apps';
import ApiKeysTab from '../../components/Integration/apiKeys';
import WebhooksTab from '../../components/Integration/webhooks';
import PhoneNumbers from '../Phone/index.js';
import CallLogs from '../Phone/CallLogs';
import SalesAccounts from './SalesAccounts';
import TitleRoute from '../../components/titleRoute.js';

/**
 * Connections Page - Hub for all connection-related features
 * - Phone Numbers
 * - Integrations (Gmail, Twilio, WhatsApp, etc.)
 * - API Keys
 * - Webhooks
 */
const Connections = () => {

    const { pathname } = window['location'];

    // Parse tab from pathname
    const getTabFromPathname = (pathname) => {
        if (pathname.includes('/sales-accounts')) return 'sales-accounts';
        if (pathname.includes('/phones')) return 'phones';
        if (pathname.includes('/call-logs')) return 'call-logs';
        if (pathname.includes('/api-keys')) return 'api-keys';
        if (pathname.includes('/webhooks')) return 'webhooks';
        if (pathname.includes('/integrations')) return 'integrations';
        return 'integrations'; // default
    };

    // Use state to track active tab
    const [activeTab, setActiveTab] = useState(() => getTabFromPathname(window['location']['pathname']));

    // Update activeTab when location changes
    useEffect(() => {
        const newTab = getTabFromPathname(window['location']['pathname']);
        setActiveTab(newTab);
    }, [window['location']['pathname']]);

    // Render content based on active tab
    const renderContent = () => {
        if (activeTab === 'sales-accounts') return <SalesAccounts />;
        if (activeTab === 'phones') return <PhoneNumbers />;
        if (activeTab === 'call-logs') return <CallLogs />;
        if (activeTab === 'api-keys') return <ApiKeysTab />;
        if (activeTab === 'webhooks') return <WebhooksTab />;
        if (activeTab === 'integrations') return <AppsTab />;
        return <AppsTab />;
    };

    // // Phone Numbers has its own page structure, render it directly
    // if (activeTab === 'phones') return <PhoneNumbers />;

    return (
        <div className='content'>
            <div className='main-container setting-container'>
                <div className='page-title-area setting-page'>
                    <TitleRoute />
                </div>
                <div className='bottom-content-area setting-bottom-content'>
                    <div className='content account-tabs connections-page-container'>
                        <div className='account-tab-inner'>
                            <div className='right-tabs-area billing-tabs'>
                                <div className='tabs-content'>
                                    {renderContent()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Connections;
